/**
 * 系统设置API配置
 * lixian
 *
 */
const api = [
  {
    name: 'department',
    method: 'GET',
    desc: '获取参数',
    path: '/sms/department'
  },
  {
    name: 'authentication',
    method: 'GET',
    desc: '认证类型',
    path: '/authentication'
  },
  {
    name: 'save',
    method: 'POST',
    desc: '获取参数',
    path: '/sms/department'
  },
  {
    name: 'getBizPayments',
    method: 'GET',
    desc: '加载结算设置数据',
    path: '/bizPaymentResource/getBizPayments'
  },
  {
    name: 'getPayMethods',
    method: 'GET',
    desc: '加载结算方式',
    path: '/bizPaymentResource/getPayMethods'
  },
  {
    name: 'getPayTypes',
    method: 'GET',
    desc: '加载结算类型',
    path: '/bizPaymentResource/getPayTypes'
  },
  {
    name: 'savePayments',
    method: 'POST',
    desc: '保存结算方式',
    path: '/bizPaymentResource/savePayments'
  },
  {
    name: 'delPayMethod',
    method: 'POST',
    desc: '删除结算方式',
    path: '/bizPaymentResource/delPayMethod'
  }
]

export default {
  BASE_URL: '/paramConfig',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/sys.js